export enum EDataTableRowTreeStatus {
  NO_CHILDREN = 'no_children',
  COLLAPSED = 'collapsed',
  LOADING = 'loading',
  EXPANDED = 'expanded',
}
